

import { useEffect } from 'react';






const useOuterClick = ({ innerRef, callback, dependencies }) => {
  useEffect(() => {
    function handleClick(e) {
      if (innerRef && innerRef.current) {
        const ref = innerRef.current;
        if (!ref.contains(e.target)) {
          callback();
        }
      }
    }

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [...dependencies]);
};

export default useOuterClick;